module.exports = __webpack_public_path__ + "img/horizontal_2_1_7005.1d2e70aa.png";